module.exports = __webpack_public_path__ + "img/triangle.918ebfab.svg";